import { BaseModel, SearchParameter } from './base.model';

export class ActivityQuestion extends BaseModel {
    id?: string;
    description?: string;
}

export class ActivityQuestionSearchParameter extends SearchParameter {
    description?: string;
  }